const dryCleaningWoman = [
	{
		id: '4201',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Trouser / Pajama)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 25,
		quantity: 1
	},

	{
		id: '4202',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Gowns (Light)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 250,
		quantity: 1
	},

	{
		id: '4203',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Gowns (Heavy)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 300,
		quantity: 1
	},
	{
		id: '4204',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Skirt (Medium)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 80,
		quantity: 1
	},
	{
		id: '4205',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Skirt (Long)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 120,
		quantity: 1
	},

	{
		id: '4206',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kitenge (1pcs)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 80,
		quantity: 1
	},

	{
		id: '4207',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kitenge (2pcs)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 200,
		quantity: 1
	},
	{
		id: '4208',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Silk clothing',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 140,
		quantity: 1
	},
	{
		id: '4209',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Cotton clothing',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 120,
		quantity: 1
	},

	{
		id: '4210',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Long Dress',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 150,
		quantity: 1
	},
	{
		id: '4211',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shawl (Ordinary)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 60,
		quantity: 1
	},
	{
		id: '4212',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shawl (Fancy)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 100,
		quantity: 1
	},
	{
		id: '4213',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Leather Jacket',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 120,
		quantity: 1
	},
	{
		id: '4214',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Gown (Other)',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 170,
		quantity: 1
	},
	{
		id: '4215',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sweater',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 80,
		quantity: 1
	},
	{
		id: '4216',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Coat',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 150,
		quantity: 1
	},
	{
		id: '4217',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Scalf',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 30,
		quantity: 1
	},
	{
		id: '4218',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shoes / Boots / High heels / Flat shoes',
		category: "Women's Wear",
		service: 'Dry Cleaning',
		price: 40,
		quantity: 1
	}
];

export default dryCleaningWoman;
